import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';

import ordersKeys from '../util/orders-keys';
import {OccurrenceProps} from '../types';

const useCreateOrderOccurrence = (orderId: string) => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: OccurrenceProps) => {
    create(ordersKeys.occurrences(orderId), data);
  };

  return useApiMutation({
    url: `/orders/${orderId}/occurrences`,
    method: 'POST',
    errorTitle: 'Erro ao cadastrar ocorrência',
    successTitle: 'Cadastrar ocorrência',
    successMessage: 'Ocorrência cadastrada com sucesso',
    redirectUrl: `/orders/${orderId}/occurrences`,
    onSuccess,
  });
};

export default useCreateOrderOccurrence;
